import { IconLayoutDashboard, IconRobot, IconBox } from "@tabler/icons-react";
import { createDockStatus } from "../general/dockStatus/createDockStatus";
import { createCustomerOperations } from "../general/customerOperations/createCustomerOperations";
import { createPlatforms } from "../general/platforms/createPlatforms";
import { type RoboticsModule } from "../types";

export const vlcModule: RoboticsModule = {
  key: "vlc",
  label: "VLC",
  defaultTab: "dock-status",
  tabs: [
    {
      value: "dock-status",
      label: "Dock Status",
      icon: IconLayoutDashboard,
      Component: createDockStatus("vlcmanagement"),
    },
    {
      value: "customer-operations",
      label: "Customer Operations",
      icon: IconRobot,
      Component: createCustomerOperations(),
    },
    {
      value: "platforms",
      label: "Platforms",
      icon: IconBox,
      Component: createPlatforms({ managementBase: "vlcmanagement", maintenance: true, tValue: true, assignUnits: true }),
    },
  ],
};
